/** INT */
export enum GenericKeysModel {
  FLOWwwer = 1,
  LPG = 2,
  Voooy = 3,
}
